export default __webpack_public_path__ + "static/media/press1.0df124e8.jpeg";